import LoginPage from "pages/authentication/Login.page";
import React from "react";
import { useRoutes, Navigate } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import GuestGuard from "utils/route-guard/GuestGuard";
import MinimalLayout from "layout/MinimalLayout";
import NavMotion from "layout/NavMotion";
import MainLayout from "layout/MainLayout";
import ChangePasswordPage from "pages/authentication/ChangePassword.page";
import RegistrationConfirmPage from "pages/authentication/RegistrationConfirm.page";
import ForgotPassword from "pages/authentication/ForgotPassword.page";
import NotFoundPage from "pages/error/NotFound";
import UsersListPage from "pages/management/users/UsersList.page";
import StationsListPage from "pages/management/stations/StationsList.page";
import MapStationsPage from "pages/gis/MapStations.page";
import MapRealtimePage from "pages/gis/MapRealtime.page";
import SettingsPage from "pages/profile/AccountProfile.page";
import HomePage from "pages/dashboard/home/Home.page";
import GlobalEnvironmentPage from "pages/environment/GlobalEnviroment.page";
import MetricsEnvironmentPage from "pages/environment/MetricsEnviroment.page";
import AnimatedMapPage from "pages/gis/AnimatedMap.page";
import StatusSensorsPage from "pages/dashboard/status-sensors/StatusSensors.page";
import WarningListPage from "pages/dashboard/warning-list/WarningList.page";
import ResendEmailPage from "pages/authentication/ResendEmail.page";
import HistoricalDataPage from "pages/environment/HistoricalData.page";
import LoadingStatusStationPage from "pages/dashboard/status-sensors/LoadingStatusStations.page";
import LoadingStationsPage from "pages/management/stations/LoadingStations.page";


const Router = ({ childProps }) => {
  return useRoutes([
    {
      path: "/dashboard",
      element: (
        <PrivateRoute>
          <MainLayout />
        </PrivateRoute>
      ),
      children: [
        {
          path: "/dashboard/home",
          element: <HomePage />,
        },
        {
          path: "/dashboard/status-sensors",
          element: <StatusSensorsPage />,
        },
        {
          path: "/dashboard/warning-list",
          element: <WarningListPage />,
        },
        {
          path: "/dashboard/management/monitoring-points-list",
          element: <StationsListPage />,
        },
        {
          path: "/dashboard/management/monitoring-points-list/:id",
          element: <LoadingStationsPage />,
        },
        {
          path: "/dashboard/status-sensors/:id",
          element: <LoadingStatusStationPage />,
        },
        {
          path: "/dashboard/management/users-list",
          element: <UsersListPage />,
        },
        {
          path: "/dashboard/global-view/map-monitoring-points",
          element: <MapStationsPage props={childProps} />,
        },
        {
          path: "/dashboard/global-view/map-realTime",
          element: <MapRealtimePage props={childProps} />,
        },
        {
          path: "/dashboard/global-view/map-animated",
          element: <AnimatedMapPage props={childProps} />,
        },
        {
          path: "/dashboard/data-sensors/metrics",
          element: <MetricsEnvironmentPage />,
        },
        {
          path: "/dashboard/data-sensors/global",
          element: <GlobalEnvironmentPage />,
        },
        {
          path: "/dashboard/data-sensors/historical-data",
          element: <HistoricalDataPage />,
        },
        {
          path: "/dashboard/profile/settings",
          element: <SettingsPage />,
        },
      ],
    },
    {
      path: "/",
      element: (
        <NavMotion>
          <GuestGuard>
            <MinimalLayout />
          </GuestGuard>
        </NavMotion>
      ),
      children: [
        {
          path: "/",
          element: <LoginPage />,
        },
        {
          path: "/login",
          element: <LoginPage />,
        },
        {
          path: "/forgot-password",
          element: <ForgotPassword />,
        },
        {
          path: "/users/passwords/change/:t",
          element: <ChangePasswordPage />,
        },
        {
          path: "/users/_confirm/:token",
          element: <RegistrationConfirmPage />,
        },
        {
          path: "/resend-confirm",
          element: <ResendEmailPage />,
        },
      ],
    },

    {
      path: "404",
      element: <NotFoundPage />,
    },
    {
      path: "*",
      element: <Navigate to="/404" replace />,
    },
  ]);
};

export default Router;
